import { createContext } from 'react';

export const TokenContext = createContext(0);
